const reloadKey = 'chunk-reload';

import('./bootstrap')
	.then(() => {
		sessionStorage.removeItem(reloadKey);
	})
	.catch((err) => {
		// Webpack throws errors with name 'ChunkLoadError' when dynamic imports fail to load
		if (err?.name === 'ChunkLoadError') {
			if (!sessionStorage.getItem(reloadKey)) {
				sessionStorage.setItem(reloadKey, 'true');
				window.location.reload();
				return;
			}
		}
		console.error(err);
	});

export {};
